export const Risk = {
    NoData: -1,
    Zero: 0,
    Low: 10,
    Intermediate: 20,
    High: 30
};